<div class="panel-header-container" [formGroup]="taxNotIncludedFormGroup">
        <div class="panel-header-row">
            <button mat-icon-button disabled class="button-expand-collapse tax-button"></button>
            <table class="full-width" >
                <tr class="custom-table-row">
                    <td class="estimate-table-column width-190">{{ 'TAX_NOT_INCLUDED' | translate}}</td>
                </tr>
            </table>
        </div>
    </div>